import React from 'react'

import Container from '../../../components/Container'
import Button from '@material-ui/core/Button'
import ValidationSummary from './ValidationSummary'
import SaveErrorMessage from './SaveErrorMessage'

import t from '../../../translations'

const SavePollButton = (props) => (
  <Container>
    <ValidationSummary
      missingCount={props.missingCount}
      lowMarkLabels={props.lowMarkLabels}
    />
    {props.saveError ? <SaveErrorMessage /> : null}
    <Button
      variant={'contained'}
      color={'primary'}
      onClick={props.onClick}
      fullWidth={true}
    >
      {t.pollView.save}
    </Button>
  </Container>
)

export default SavePollButton
